module.exports = __webpack_public_path__ + "static/media/share.aa0d6fa3.svg";